import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppMode } from "@/hooks/useAppMode";
import { useAuth } from "@/hooks/useAuth";
import { useOrganization } from "@/hooks/useOrganization";
import { Card, CardContent } from "@/components/ui/card";
import { LayoutDashboard } from "lucide-react";
import SportIcon from "@/components/SportIcon";

export default function ViewSelector() {
  const { t } = useTranslation("common");
  const { setMode } = useAppMode();
  const { profile } = useAuth();
  const { organization } = useOrganization();
  const navigate = useNavigate();
  const firstName = profile?.full_name?.split(" ")[0] || t("viewSelector.userFallback");

  const choose = (mode: "player" | "manager") => {
    setMode(mode);
    navigate(mode === "manager" ? "/manager/dashboard" : "/");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div>
          <h1 className="text-2xl font-bold">{t("viewSelector.welcomeBack", { name: firstName })}</h1>
          <p className="text-muted-foreground mt-1">{t("viewSelector.chooseView")}</p>
        </div>

        <div className="grid gap-4">
          <Card
            className="cursor-pointer hover:border-primary/50 hover:bg-primary/5 transition-colors"
            onClick={() => choose("player")}
          >
            <CardContent className="flex items-center gap-4 p-6">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
                <SportIcon sport={(organization?.settings as any)?.sport_type} size="lg" className="text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-lg">{t("viewSelector.playerApp")}</p>
                <p className="text-sm text-muted-foreground">{t("viewSelector.playerAppDesc")}</p>
              </div>
            </CardContent>
          </Card>

          <Card
            className="cursor-pointer hover:border-primary/50 hover:bg-primary/5 transition-colors"
            onClick={() => choose("manager")}
          >
            <CardContent className="flex items-center gap-4 p-6">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-secondary/30">
                <LayoutDashboard className="h-7 w-7 text-secondary-foreground" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-lg">{t("viewSelector.adminPanel")}</p>
                <p className="text-sm text-muted-foreground">{t("viewSelector.adminPanelDesc")}</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
